const getters = {
    adaptive_bulb: state => _.chain(state.complexity_levels).flattenDeep().some().value(),
    bulb_complexity: state => state.bulb_complexity,
    complexity_levels: state => state.complexity_levels,
    nsf_id: state => state.nsf_id,
    segment_complexity: state => state.segment_complexity,
    treatment: state => state.treatment,
}

export default getters;
